var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTournamentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "46.000000pt",
    height: "44.000000pt",
    viewBox: "0 0 46.000000 44.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,44.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 430 c0 -6 30 -10 70 -10 l70 0 0 -60 0 -60 -70 0 c-40 0 -70 -4 -70 -10 0 -6 33 -10 80 -10 l80 0 0 35 0 35 70 0 70 0 0 -130 0 -130 -70 0 -70 0 0 35 0 35 -80 0 c-47 0 -80 -4 -80 -10 0 -6 30 -10 70 -10 l70 0 0 -60 0 -60 -70 0 c-40 0 -70 -4 -70 -10 0 -6 33 -10 80 -10 l80 0 0 35 0 35 80 0 80 0 0 70 0 70 70 0 c40 0 70 4 70 10 0 6 -30 10 -70 10 l-70 0 0 70 0 70 -80 0 -80 0 0 35 0 35 -80 0 c-47 0 -80 -4 -80 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentIcon);
export default __webpack_public_path__ + "static/media/TournamentIcon.843f35890d2534745be4b9cf2cb0b46a.svg";
export { ForwardRef as ReactComponent };